module.exports = __webpack_public_path__ + "media/images/theme/isc/logo-large-07257637556320f0fd53dd5c66c9d918.png";